import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useToast } from "@/hooks/use-toast";
import { CLINIC } from "@/constants/testIds";

/** Card de Ajustes: boton flotante de WhatsApp en la pagina publica de
 * reservas. Desactivado por defecto (numero/mensaje configurables). */
export default function PublicWhatsAppHelpCard({ clinic, onUpdated }) {
  const [enabled, setEnabled] = useState(clinic.public_whatsapp_help_enabled ?? false);
  const [number, setNumber] = useState(clinic.public_whatsapp_help_number || "");
  const [message, setMessage] = useState(clinic.public_whatsapp_help_message || "Hola, tengo una consulta sobre...");
  const [saving, setSaving] = useState(false);
  const { toast } = useToast();

  const handleSave = async () => {
    setSaving(true);
    try {
      const { data } = await api.put("/clinic", {
        public_whatsapp_help_enabled: enabled,
        public_whatsapp_help_number: number || null,
        public_whatsapp_help_message: message || null,
      });
      onUpdated(data);
      toast({ title: "Botón de WhatsApp actualizado" });
    } catch (err) {
      toast({ title: "Error al guardar", description: formatApiErrorDetail(err.response?.data?.detail), variant: "destructive" });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-white border border-border rounded-xl p-6 sm:p-8 shadow-sm space-y-5">
      <div className="flex items-center justify-between gap-4">
        <div>
          <h2 className="font-serif text-xl text-foreground">Botón de ayuda por WhatsApp</h2>
          <p className="text-sm text-muted-foreground mt-1">
            Muestra un botón flotante en la página pública de reservas para que las pacientes consulten por WhatsApp.
          </p>
        </div>
        <Switch checked={enabled} onCheckedChange={setEnabled} data-testid={CLINIC.whatsappHelpToggle} />
      </div>

      <div>
        <Label className="text-sm text-muted-foreground mb-1 block">Número de WhatsApp (con código de país)</Label>
        <Input value={number} onChange={(e) => setNumber(e.target.value)} placeholder="+1 713 555 0100" data-testid={CLINIC.whatsappHelpNumberInput} />
        <p className="text-xs text-muted-foreground mt-1">
          Si todavía usás el Sandbox de Twilio, dejalo desactivado: ese número exige un código de activación y no responderá a mensajes nuevos.
        </p>
      </div>

      <div>
        <Label className="text-sm text-muted-foreground mb-1 block">Mensaje inicial</Label>
        <Input value={message} onChange={(e) => setMessage(e.target.value)} data-testid={CLINIC.whatsappHelpMessageInput} />
      </div>

      <Button onClick={handleSave} disabled={saving} className="bg-brand hover:bg-brand-hover text-white" data-testid={CLINIC.whatsappHelpSaveButton}>
        {saving ? "Guardando..." : "Guardar cambios"}
      </Button>
    </div>
  );
}
